import { Rect, SetStyles } from "../.././MyHelpers";
import { ImageResource } from "../../ResourceManager/ImageResource";
import { Resourceful } from "../../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager } from "../../ResourceManager/ResourceManager";
import { Settings, SourcePickbonus } from "../../Settings";
import { PickBonus2Params } from "./PickBonus2";
import { PickBonusJackpotReward, PickBonusReward } from "./PickBonusParams";

export class PickJackpot implements Resourceful
{
	protected view:HTMLElement = null;
	protected resid:ResourceIdentifier = null;
	protected params: PickBonus2Params = null;
	protected requiredToHit:number;
	protected jpName:string = "";

	protected jpFrame:HTMLElement = null;
	protected jpWin: HTMLElement = null;
	protected winContainer:HTMLElement [] = [];

	//protected jpLogo:HTMLElement= null;

	protected JpSequence:number = 0;

	constructor(jpName:string ,resid:ResourceIdentifier, params:PickBonus2Params, requiredToHit:number, Jp:number)
	{
		this.jpName = jpName;
		this.resid = resid.Add(this.jpName);
		this.params = params;
		this.requiredToHit = requiredToHit;
		this.JpSequence = Jp;

		this.view = document.createElement("div");
		this.view.classList.add(this.resid.Scope());
		this.view.classList.add("JackpotContainer");
		SetStyles(this.view,
		{
			width: "22%",
			height: "100%",
			display: "flex",
			flexFlow: "row",
			justifyContent: "flex-start",
			flexWrap: "wrap",
		});

		/* this.view.style.width = "20%";
		this.view.style.height = "100%";
		this.view.style.color = "yellow";
		this.view.style.fontSize ="30px";
		this.view.style.display = "flex";
		this.view.style.flexFlow ="row";
		this.view.style.justifyContent = "center"; */

	/* 	this.jpLogo = document.createElement("div");
		this.jpLogo.classList.add(this.resid.Scope());
		this.jpLogo.classList.add("JackpotLogo");
		//this.jpLogo.style.position = "absolute";
		this.jpLogo.style.width = "50px";
		this.jpLogo.style.height = "50px";
		this.jpLogo.style.top = "50%";
		this.jpLogo.style.left = "10%";
		this.jpLogo.style.fontSize = "40px"; */
		//this.jpLogo.style.color = "yellow";
		//this.jpLogo.innerHTML = this.jpName;

		//this.view.appendChild(this.jpLogo);
	}

	public PrepareResources(resourceManager: IWriteOnlyResourceManager):void
	{
		this.PrepareJpFrame(resourceManager);
	}

	public ResourcesLoaded(resourceManager: IReadOnlyResourceManager):void 
	{
		this.JpFramesLoaded(resourceManager);
	}
	
	protected PrepareJpFrame(resourceManager: IWriteOnlyResourceManager):void
	{
		//USE ONLY FOR DRAGON LINK
		if(Settings.SourcePick == SourcePickbonus.DragonLink )
		{
		//resourceManager.Add(new ImageResource(this.params.gameResourcesBasePath + "jpFrame.png", this.resid.ScopedResourceName(["frame", "image"])));
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath+"DragonImage/frame1.png", this.resid.ScopedResourceName(["frame"+0, "image"])));
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "DragonImage/frame2.png", this.resid.ScopedResourceName(["frame"+1, "image"])));
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "DragonImage/frame3.png", this.resid.ScopedResourceName(["frame"+2, "image"])));
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath +"DragonImage/frame4.png", this.resid.ScopedResourceName(["frame"+3, "image"])));
	
		}
		//USE ONLY FOR DIAMON POT
		if(Settings.SourcePick == SourcePickbonus.Ortiz )
		{
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath+"frame1.png", this.resid.ScopedResourceName(["frame"+0, "image"])));
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath  + "frame2.png", this.resid.ScopedResourceName(["frame"+1, "image"])));
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath  + "frame3.png", this.resid.ScopedResourceName(["frame"+2, "image"])));
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath  +"frame4.png", this.resid.ScopedResourceName(["frame"+3, "image"])));
		}
	}

	protected JpFramesLoaded(resourceManager: IReadOnlyResourceManager):void
	{	
		for(let i = 0; i < this.requiredToHit ; i++)
		{
			

			this.jpFrame = document.createElement("div");
			this.jpFrame.classList.add(this.resid.Scope());
			this.jpFrame.classList.add("jpFrame");
			SetStyles(this.jpFrame,
			{
				width:"50%",
				height: "50%",
				backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["frame"+this.JpSequence, "image"])).CssBackground(),
				backgroundRepeat : "no-repeat",
				backgroundSize : "contain",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",

			});
			/* this.jpFrame.style.width = "20%";
			this.jpFrame.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["frame"+this.JpSequence, "image"])).CssBackground();
			this.jpFrame.style.backgroundRepeat = "no-repeat";
			this.jpFrame.style.backgroundSize = "contain"; */
			
			
			this.jpWin = document.createElement("div");
			this.jpWin.classList.add(this.resid.Scope());
			this.jpWin.classList.add("jpWin");
			SetStyles(this.jpWin,
			{
				width :"70%",
				margin: "10%",
				height :"70%",
				backgroundRepeat:"no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				zIndex:"3"

			});


			//this.jpWin.style.border ="2px solid yellow";
			/* this.jpWin.style.width = "80%";
			this.jpWin.style.margin = "10%";
			this.jpWin.style.height = "60%";
			this.jpWin.style.backgroundRepeat = "no-repeat";
			this.jpWin.style.backgroundSize = "contain";
			this.jpWin.style.backgroundPosition = "center"; */

			this.winContainer.push(this.jpWin);
			this.jpFrame.appendChild(this.jpWin);
			this.view.appendChild(this.jpFrame);
				
		}

	}

	public CenterOfFreeSpaceForDiamond(award:PickBonusReward): Rect
	{
		//let jackpot:PickJackpot = this.pickJackpots.get(this.pickedAward.JackpotName);
		let freeSpotForJackpot:number = (award as PickBonusJackpotReward).JackpotCount-1;
		if (freeSpotForJackpot >= this.winContainer.length)
		{
			freeSpotForJackpot = this.winContainer.length-1;
		}

		let W:HTMLElement = this.winContainer[freeSpotForJackpot];
		
		let winX:number =W.offsetLeft + this.view.parentElement.offsetLeft;// W.parentElement.parentElement.offsetLeft+ W.parentElement.parentElement.parentElement.offsetLeft;
		let winY:number = W.offsetTop + this.view.parentElement.offsetTop; //W.parentElement.offsetTop + W.parentElement.parentElement.offsetTop +W.parentElement.parentElement.parentElement.offsetTop;
		let winWidth:number = W.offsetWidth;
		let winHeight:number = W.offsetHeight;
		let winRect: Rect = new Rect(winX,winY,winWidth, winHeight);
		return winRect;
	}

	public JpFreeSpot(count:number):number
	{
		let freeSpot:number = count-1;
		if (freeSpot >= this.winContainer.length)
		{
			freeSpot = this.winContainer.length-1;
		}
		return freeSpot;
	}

	public WinContainer():HTMLElement[]
	{
		return this.winContainer;
	}

	public View():HTMLElement
	{
		return this.view;
	}
}
